import React from 'react';
import { Link } from 'react-router-dom';
import { ENTITY_BADGES } from '../config/platformNav';

function EntityDetailLayout({
  entityType,
  title,
  subtitle,
  breadcrumbs = [],
  tabs = [],
  activeTab,
  onTabChange,
  headerActions,
  sidebar,
  loading,
  notFound,
  notFoundAction,
  children,
}) {
  const badge = ENTITY_BADGES[entityType] || { label: entityType?.toUpperCase(), className: 'entity-badge-default' };

  if (loading) {
    return (
      <div className="entity-detail">
        <div className="main-body">
          <p style={{ color: 'var(--hdp-text-muted)' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="entity-detail">
        <div className="main-body">
          <p style={{ color: 'var(--hdp-danger)' }}>{notFound}</p>
          {notFoundAction}
        </div>
      </div>
    );
  }

  return (
    <div className="entity-detail">
      {breadcrumbs.length > 0 && (
        <nav className="entity-breadcrumbs" aria-label="Breadcrumb">
          {breadcrumbs.map((crumb, index) => (
            <span key={`${crumb.label}-${index}`} className="entity-breadcrumb-item">
              {crumb.to ? (
                <Link to={crumb.to}>{crumb.label}</Link>
              ) : (
                <span>{crumb.label}</span>
              )}
              {index < breadcrumbs.length - 1 && <span className="entity-breadcrumb-sep">›</span>}
            </span>
          ))}
        </nav>
      )}

      <header className="entity-header">
        <div className="entity-header-main">
          <div className="entity-header-titles">
            <div className="entity-title-row">
              <span className={`entity-badge ${badge.className}`}>{badge.label}</span>
              <h1 className="entity-title">{title}</h1>
            </div>
            {subtitle && <p className="entity-subtitle">{subtitle}</p>}
          </div>
          {headerActions && <div className="entity-header-actions">{headerActions}</div>}
        </div>

        {tabs.length > 0 && (
          <div className="entity-tabs" role="tablist">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                className={`entity-tab ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => onTabChange(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </header>

      <div className="entity-body">
        <div className="entity-main">{children}</div>
        {sidebar && <aside className="entity-sidebar">{sidebar}</aside>}
      </div>
    </div>
  );
}

export default EntityDetailLayout;
